const state = {
  page: 1,
  all: [],
  isLoading: false,
  disablePagination: false,
  filter: null,
  allDeliveriesSelected: false,
  requestDetails: {},
  requestPage: 1,
  transporterPagination: 1,
};
export default state;
